import { Component, Input } from "@angular/core";
import { ListingHistory } from "../listing-history";
import { ListingAudit } from "../listing-audit";

const isListingHistory = (data): data is ListingHistory => {
	return (data as ListingHistory).listingHistorySK !== undefined;
};

const isListingAudit = (data): data is ListingAudit => {
	return (data as ListingAudit).listingAuditSK !== undefined;
};

@Component({
	selector: "app-history-item",
	templateUrl: "./history-item.component.html",
	styleUrls: ["./history-item.component.scss"],
})
export class HistoryItemComponent {
	@Input() historyData: ListingHistory | ListingAudit;
	@Input() showDifference = false;
	maxVisibleChars: number = 200;

	get before(): any {
		if (isListingHistory(this.historyData)) {
			const historyData = this.historyData as ListingHistory;
			return historyData?.decodedBeforeValue || historyData?.codedBeforeValue || "";
		} else if (isListingAudit(this.historyData)) {
			const auditData = this.historyData as ListingAudit;
			return auditData?.beforeValue || "";
		} else {
			return "";
		}
	}

	get after(): any {
		if (isListingHistory(this.historyData)) {
			const historyData = this.historyData as ListingHistory;
			return historyData?.decodedAfterValue || historyData?.codedAfterValue || "";
		} else if (isListingAudit(this.historyData)) {
			const auditData = this.historyData as ListingAudit;
			return auditData?.afterValue || "";
		} else {
			return "";
		}
	}

	get isDeleted(): boolean {
		let deleted = false;
		if (isListingAudit(this.historyData)) {
			deleted = !!this.historyData?.deleteDTTM;
		}

		return deleted;
	}

	constructor() {}
}
